export default "__VITE_ASSET__BiMwebIE__"